import React from "react";

export function FilterIcon({ color = "#FFF", ...props }) {
  return (
    <svg width="16" height="18" viewBox="0 0 16 18" xmlns="http://www.w3.org/2000/svg" fill={color} {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M8 0.5C12 0.5 16 2 16 3.5C16 3.64528 15.897 3.89163 15.4949 4.20912C15.1072 4.51517 14.5211 4.82099 13.7681 5.09206C12.267 5.63247 10.2002 6 8 6C5.79977 6 3.73301 5.63247 2.23186 5.09206C1.4789 4.82099 0.892791 4.51517 0.505135 4.20912C0.10298 3.89163 0 3.64528 0 3.5C0 2 4 0.5 8 0.5ZM1.37313 5.83084L6 12V18L10 16V12L14.6269 5.83084C14.4597 5.90101 14.2861 5.96842 14.1069 6.03294C12.483 6.61753 10.2998 7 8 7C5.70023 7 3.51699 6.61753 1.89314 6.03294C1.71391 5.96842 1.5403 5.90101 1.37313 5.83084Z" />
    </svg>
  );
}
